import { Col, InputGroup, Label, Row } from "reactstrap";
import InputSearch from "../Inputs/InputSearch";
import Select, { components } from "react-select";
import InputDateRange from "../Inputs/InputDateRange";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import "./styles.scss";
import { connect } from "react-redux";
import { getFilterData } from "../../store/filterBar/actions";
import FILTER_LAYOUT from "./filterLayout";

const FilterBar = ({
  setObjFilter,
  placeholderSearch,
  isFirstRender,
  variant,

  regions,
  business,
  products,
  users,

  sections,
  snippets,

  loading,
  getFilterDataRequest,
}) => {
  const [searchFilter, setSearchFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(
  variant?.toLowerCase() === "bulk" ? optionsStatus[0] : optionsStatus[1]
);
  const [createDateFilter, setCreateDateFilter] = useState("");
  const [updateDateFilter, setUpdateDateFilter] = useState("");

  const [regionFilter, setRegionFilter] = useState([]);
  const [businessFilter, setBusinessFilter] = useState([]);
  const [productsFilter, setProductsFilter] = useState([]);

  const [sectionsFilter, setSectionsFilter] = useState([]);
  const [snippetsFilter, setSnippetsFilter] = useState([]);
  const [statusWorkflowFilter, setStatusWorkflowFilter] = useState([]);

  const [createdByUserFilter, setCreatedByUserFilter] = useState([]);
  const [updatedByUserFilter, setUpdatedByUserFilter] = useState([]);

  const [typeFilter, setTypeFilter] = useState([]);

  const inputCreateDateRef = useRef(null);
  const inputUpdateDateRef = useRef(null);
  const handleClearFilters = () => {
    setSearchFilter("");
    setStatusFilter(null);
    setCreateDateFilter("");
    setUpdateDateFilter("");
    setRegionFilter([]);
    setSnippetsFilter([]);
    setStatusWorkflowFilter([]);
    setBusinessFilter([]);
    setProductsFilter([]);
    setSectionsFilter([]);
    setCreatedByUserFilter([]);
    setUpdatedByUserFilter([]);
    setTypeFilter([]);

    inputCreateDateRef.current.altInput.classList.remove("input-date-selected");
    inputCreateDateRef.current.altInput.style.backgroundColor = "#FFF";
    inputUpdateDateRef.current.altInput.classList.remove("input-date-selected");
    inputUpdateDateRef.current.altInput.style.backgroundColor = "#FFF";
  };
  const CustomClear = ({ children, ...props }) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888", cursor: "pointer" }}
      ></i>
    </components.ClearIndicator>
  );
  const customStyles = {
    singleValue: (base, state) => ({
      ...base,
      color: state.isSelected ? "#9599AD" : "#0576B9",
      fontWeight: "700",
      fontSize: "14px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
      fontSize: "14px",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "#E1E5EF"
        : state.isSelected
          ? "#D2D8E7"
          : "#FFF",
      color: "#000000DE",
      fontWeight: "500",
      fontSize: "14px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#E1E5EF",
      },
    }),
  };

  const renderFilter = (key, col) => {
    switch (key) {
      case "search":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Search</Label>
            <InputGroup>
              <InputSearch
                placeholderSearch={placeholderSearch}
                searchValueFilter={searchFilter}
                setSearchValueFilter={setSearchFilter}
              />
            </InputGroup>
          </Col>
        );

        case "status":
            return (
            <Col {...col} key={key}>
                <Label className="label-filter">Active status</Label>
                <Select
                className="filter-select"
                options={optionsStatus}
                value={statusFilter}
                onChange={setStatusFilter}
                styles={customStyles}
                placeholder="Select status"
                />
            </Col>
            );

      case "createDate":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Creation Date</Label>
            <InputDateRange
              dateValueFilter={createDateFilter}
              setDateValueFilter={setCreateDateFilter}
              flatpickrRef={inputCreateDateRef}
            />
          </Col>
        );

      case "updateDate":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Update Date</Label>
            <InputDateRange
              dateValueFilter={updateDateFilter}
              setDateValueFilter={setUpdateDateFilter}
              flatpickrRef={inputUpdateDateRef}
            />
          </Col>
        );

      case "region":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Region</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={regions}
              value={regionFilter}
              onChange={(value) => setRegionFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select region"}
            />
          </Col>
        );

      case "business":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Business</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={business}
              value={businessFilter}
              onChange={(value) => setBusinessFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select business"}
            />
          </Col>
        );

      case "products":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Products</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={products}
              value={productsFilter}
              onChange={(value) => setProductsFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select product"}
            />
          </Col>
        );

      case "sections":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Sections</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={sections}
              value={sectionsFilter}
              onChange={(value) => setSectionsFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select section"}
            />
          </Col>
        );

      case "snippets":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Snippets</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={snippets}
              value={snippetsFilter}
              onChange={(value) => setSnippetsFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select snippet"}
            />
          </Col>
        );

      case "statusWorkflow":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Status</Label>
            <Select
              isMulti
              isClearable
              components={{ ClearIndicator: CustomClear }}
              options={optionsStatusWorkflow}
              value={statusWorkflowFilter}
              onChange={setStatusWorkflowFilter}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select status"}
            />
          </Col>
        );

      case "createdBy":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Created by</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={users}
              value={createdByUserFilter}
              onChange={(value) => setCreatedByUserFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select user"}
            />
          </Col>
        );

      case "updatedBy":
        return (
          <Col {...col} key={key}>
            <Label className="label-filter">Updated by</Label>
            <Select
              isMulti
              components={{ ClearIndicator: CustomClear }}
              options={users}
              value={updatedByUserFilter}
              onChange={(value) => setUpdatedByUserFilter(value ?? [])}
              isClearable
              isDisabled={loading}
              styles={customStyles}
              placeholder={loading ? "Loading..." : "Select user"}
            />
          </Col>
        );

      case "RIS":
        return (
          <Col {...col} key={key} style={{ width: "fit-content" }}>
            <div className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                id="ris"
                name="ris"
                className="form-check-input mt-0"
                onChange={() => handleTypeChange("RIS")}
                checked={typeFilter.includes("RIS")}
              />
              <label
                htmlFor="ris"
                label="RIS"
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                RIS
              </label>
            </div>
          </Col>
        );

      case "PSIS":
        return (
          <Col {...col} key={key} style={{ width: "fit-content" }}>
            <div className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                id="psis"
                name="psis"
                className="form-check-input mt-0"
                onChange={() => handleTypeChange("PSIS")}
                checked={typeFilter.includes("PSIS")}
              />
              <label
                htmlFor="psis"
                label="PSIS"
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                PSIS
              </label>
            </div>
          </Col>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      const objFilter = {
        status:
          statusFilter !== null
            ? statusFilter.value === 2
              ? true
              : statusFilter.value === 3
                ? false
                : null
            : null,
        createDateStart:
          createDateFilter !== ""
            ? moment(createDateFilter[0]).format("YYYY-MM-DD").toString()
            : "",
        createDateEnd:
          createDateFilter !== ""
            ? moment(createDateFilter[1]).format("YYYY-MM-DD").toString()
            : "",
        updateDateStart:
          updateDateFilter !== ""
            ? moment(updateDateFilter[0]).format("YYYY-MM-DD").toString()
            : "",
        updateDateEnd:
          updateDateFilter !== ""
            ? moment(updateDateFilter[1]).format("YYYY-MM-DD").toString()
            : "",

        regions: regionFilter.length ? regionFilter.map((r) => r.value) : [],
        business: businessFilter.length
          ? businessFilter.map((b) => b.value)
          : [],
        products: productsFilter.length
          ? productsFilter.map((p) => p.value)
          : [],

        sections: sectionsFilter.length
          ? sectionsFilter.map((s) => s.value)
          : [],
        snippets: snippetsFilter.length
          ? snippetsFilter.map((s) => s.value)
          : [],
        statusWorkflow: statusWorkflowFilter.length
          ? statusWorkflowFilter.map((u) => u.value)
          : [],
        createUsers: createdByUserFilter.length
          ? createdByUserFilter.map((u) => u.value)
          : [],
        updateUsers: updatedByUserFilter.length
          ? updatedByUserFilter.map((u) => u.value)
          : [],

        searchText: searchFilter,

        type: typeFilter,
      };

      if (!isFirstRender) setObjFilter(objFilter);
    }, 500);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [
    searchFilter,
    statusFilter,
    createDateFilter,
    updateDateFilter,
    regionFilter,
    businessFilter,
    productsFilter,
    sectionsFilter,
    snippetsFilter,
    statusWorkflowFilter,
    createdByUserFilter,
    updatedByUserFilter,
    typeFilter,
  ]);

  useEffect(() => {
    getFilterDataRequest({ page: variant });
  }, [getFilterDataRequest, variant]);

  const handleTypeChange = (type) => {
    setTypeFilter((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type],
    );
  };

  return (
    <>
      {FILTER_LAYOUT[variant]?.map((row, index) => (
        <Row key={index} className="mb-0 mb-md-3 mt-0 mt-md-3">
          {row.map(({ key, col }) => renderFilter(key, col))}
        </Row>
      ))}

      <Row className="d-flex justify-content-end my-2">
        <p className="clear-link" onClick={handleClearFilters}>
          Clear All
        </p>
      </Row>
      <Row className="mb-4">
        <hr className="my-3 border-4 border-top braskemGray200 opacity-100" />
      </Row>
    </>
  );
};

const optionsStatus = [
  { value: 1, label: "All" },
  { value: 2, label: "Active" },
  { value: 3, label: "Inactive" },
];
const optionsStatusWorkflow = [
  { value: "Draft", label: "Draft" },
  { value: "Review", label: "Review" },
  { value: "Approved", label: "Approved" },
  { value: "Published", label: "Published" },
  { value: "Obsolete", label: "Obsolete" },
];

const mapStateToProps = ({
  FilterBarReducer: {
    regions,
    business,
    products,
    sections,
    snippets,
    users,
    loadingFilterData,
  },
}) => ({
  regions,
  business,
  products,
  sections,
  snippets,
  users,
  loading: loadingFilterData,
});

const mapDispatchToProps = {
  getFilterDataRequest: getFilterData.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);
